var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 520.5 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: #081f2a;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.1,77.9c0-7.5,5.5-12.2,12.6-12.2s6.8,1.2,8.7,3.4l-3.8,3.8c-1.1-1.4-2.9-2.1-4.7-2.1-3.9,0-6.7,3-6.7,7.1s2.7,7.1,6.6,7.1,3.9-1,4.9-2.4l3.9,3.7c-2,2.4-5.1,3.8-9,3.8-7.2,0-12.5-5-12.5-12.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.1,77.8c0-7.5,5.4-12.2,12.7-12.2s12.7,4.7,12.7,12.2-5.4,12.4-12.7,12.4-12.7-5-12.7-12.4ZM180.5,77.8c0-4.1-2.7-7.1-6.7-7.1s-6.6,3-6.6,7.1,2.7,7.2,6.6,7.2,6.7-3,6.7-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196.8,66.3h5.7v18.4h9v4.9h-14.7v-23.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.6,66.3h5.7v18.4h9v4.9h-14.7v-23.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.5,66.3h15.7v4.8h-10.2v4.4h9.7v4.5h-9.7v4.8h10.8v4.8h-16.3v-23.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M270,77.9c0-7.5,5.5-12.2,12.6-12.2s6.8,1.2,8.7,3.4l-3.8,3.8c-1.1-1.4-2.9-2.1-4.7-2.1-3.9,0-6.7,3-6.7,7.1s2.7,7.1,6.6,7.1,3.9-1,4.9-2.4l3.9,3.7c-2,2.4-5.1,3.8-9,3.8-7.2,0-12.5-5-12.5-12.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M304.7,71.1h-6.6v-4.8h18.8v4.8h-6.6v18.5h-5.6v-18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M326,66.3h5.7v23.3h-5.7v-23.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M340.1,66.3h6.3l5.4,16.5h.1l5.4-16.5h6.2l-9,23.3h-5.6l-8.8-23.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372,66.3h15.7v4.8h-10.2v4.4h9.7v4.5h-9.7v4.8h10.8v4.8h-16.3v-23.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177,13.6v6h17v1.6c0,1.5-1.2,2.8-2.6,2.8h-21.8c-1.4,0-2.6-1.2-2.6-2.8v-10.9c0-1.5,1.2-2.8,2.6-2.8h21.8c1.4,0,2.6,1.2,2.6,2.8v.4h0c0,0,8,0,8,0h0s-.1-2-.1-2c-.3-4.4-3.7-8-8.1-8h-13.3c0-.1-13.3,0-13.3,0-4.5,0-7.7,3.6-8.1,8-.4,4.8-.4,9.3,0,14.1.3,4.4,3.7,8,8.1,8h13.3c0,.1,13.3,0,13.3,0,4.5,0,7.8-3.6,8.2-8,.3-3.1.2-6.1.2-9.1h-25.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "435.2 23.4 435.2 18.8 461.4 18.8 461.4 12.6 435.2 12.6 435.2 7.9 465.5 7.9 465.5 1.2 426.9 1.2 426.9 30.2 465.5 30.2 465.5 23.4 435.2 23.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "397 23.3 381.5 1.2 371.3 1.2 392 30.2 397 30.2 397 30.2 402 30.2 422.7 1.2 412.5 1.2 397 23.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "142.8 20.6 118.6 1.2 105.6 1.2 105.6 30.2 114 30.2 114.1 8.6 140.9 30.2 151.2 30.2 151.2 1.2 142.8 1.2 142.8 20.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "248.9 7.9 248.9 1.2 210.3 1.2 210.3 30.2 248.9 30.2 248.9 23.4 218.6 23.4 218.6 18.8 244.8 18.8 244.8 12.6 218.6 12.6 218.6 7.9 248.9 7.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.6,1.2l-20.7,29h10.2s4.1-5.8,4.1-5.8h22.8s4.1,5.8,4.1,5.8h10.2S80.6,1.2,80.6,1.2c-3.3,0-6.7,0-10,0ZM75.6,18.3h0s-7.2,0-7.2,0l7.2-10.2,7.2,10.2h-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.6,10.6c0-5.2-4.2-9.4-9.4-9.4H1.4v29h8.3s0-10.2,0-10.2h17.5l8.5,10.2h11l-8.8-10.5c3.9-1.2,6.7-4.8,6.7-9ZM33.2,13.2h-.2s-23.3,0-23.3,0v-5.2h23.5c1.4,0,2.6,1.2,2.6,2.6s-1.2,2.6-2.6,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.1,10.6c0-5.2-4.2-9.4-9.4-9.4h-33.8v29h8.3s0-10.2,0-10.2h17.5l8.5,10.2h11l-8.8-10.5c3.9-1.2,6.7-4.8,6.7-9ZM306.7,13.2h-.2s-23.3,0-23.3,0v-5.2h23.5c1.4,0,2.6,1.2,2.6,2.6s-1.2,2.6-2.6,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M510.1,19.6c3.9-1.2,6.7-4.8,6.7-9s-4.2-9.4-9.4-9.4h-33.8v29h8.3s0-10.2,0-10.2h17.5l8.5,10.2h11l-8.8-10.5ZM505.4,13.2h-.2s-23.3,0-23.3,0v-5.2h23.5c1.4,0,2.6,1.2,2.6,2.6s-1.2,2.6-2.6,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.7,8.6c-.3-4.4-3.7-8-8.1-8h-13.3c0-.1-13.3,0-13.3,0-4.5,0-7.7,3.6-8.1,8l-.3,3.1v3.9c-.1,0,0,3.1,0,3.1l.3,3.9c.3,4.4,3.7,8,8.1,8h13.2c0,.1,13.3,0,13.3,0,4.5,0,7.7-3.6,8.1-8l.3-3.1v-3.9c0,0,0-3.1,0-3.1l-.3-3.9ZM360.8,21.1c0,1.5-1.2,2.8-2.6,2.8h-21.8c-1.4,0-2.6-1.2-2.6-2.8v-10.9c0-1.5,1.2-2.8,2.6-2.8h21.8c1.4,0,2.6,1.2,2.6,2.8v10.9Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.16b867a9faa0e2c686e15b55b31945b2.svg";
export { ForwardRef as ReactComponent };